import SelectedCustomer from '@/platform/common/components/SelectedCustomer/SelectedCustomer';
import { Header, TabNav, TabNavItem } from '@/platform/ui';
import { Link, usePage } from '@inertiajs/react';

const Navigation = () => {
    const { auth } = usePage().props;
    const { component } = usePage();

    return (
        <>
            <SelectedCustomer />

            <Header as='h2'>No-riskpolis</Header>

            <TabNav label='Pagina'>
                {auth?.permissions?.includes('view no-risk') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/no-risk/employees`}
                        active={'NoRisk/CustomerIndexView' === component}
                    >
                        Werknemers
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('edit no-risk settings') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/no-risk/settings/customers`}
                        active={'NoRisk/CustomerSettingView' === component}
                    >
                        Klant instellingen
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('edit no-risk settings') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/no-risk/settings/entities`}
                        active={'NoRisk/EntitySettingView' === component}
                    >
                        Entiteiten instellingen
                    </TabNavItem>
                )}
                {auth?.permissions?.includes('update questionnaires') && (
                    <TabNavItem
                        as={Link}
                        href={`/customers/${auth?.user?.selected_customer_id}/services/no-risk/settings/questionnaires`}
                        active={
                            'NoRisk/QuestionnaireSettingsView' === component
                        }
                    >
                        Vragenlijst instellingen
                    </TabNavItem>
                )}
            </TabNav>
        </>
    );
};

export default Navigation;
